import { Pipe, PipeTransform } from '@angular/core';
import {ProductBasicModel} from '../../models/select-plans/product-basic.model';

@Pipe({
  name: 'filterBasic'
})
export class DisplaySearchProductPipe implements PipeTransform {

  transform(insurancePlanList: Array<ProductBasicModel>, searchForm: string): any {
    if (searchForm == null) {
      searchForm = '';
    }
    return searchForm
      ? insurancePlanList.filter(item => (item.productCode.toLocaleUpperCase().indexOf(searchForm.toLocaleUpperCase()) !== -1)
        || (item.productName.toLocaleUpperCase().indexOf(searchForm.toLocaleUpperCase()) !== -1))
      : insurancePlanList;
  }

}
